/**
 * TanStack Query hooks for `flat-fee-percentage-fixed-commission-payouts-per-influencer`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	flatFeePercentageFixedCommissionPayoutsPerInfluencerQueryKeys,
	type CreateFlatFeePercentageFixedCommissionPayoutsPerInfluencerBody,
	type ListFlatFeePercentageFixedCommissionPayoutsPerInfluencerResponse,
	type FlatFeePercentageFixedCommissionPayoutsPerInfluencerRow,
} from "./api";

export function useFlatFeePercentageFixedCommissionPayoutsPerInfluencerList(): UseQueryResult<ListFlatFeePercentageFixedCommissionPayoutsPerInfluencerResponse, Error> {
	return useQuery({
		queryKey: flatFeePercentageFixedCommissionPayoutsPerInfluencerQueryKeys.list(),
		queryFn: list,
	});
}

export function useFlatFeePercentageFixedCommissionPayoutsPerInfluencerCreate(): UseMutationResult<FlatFeePercentageFixedCommissionPayoutsPerInfluencerRow, Error, CreateFlatFeePercentageFixedCommissionPayoutsPerInfluencerBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: flatFeePercentageFixedCommissionPayoutsPerInfluencerQueryKeys.all });
		},
	});
}

export function useFlatFeePercentageFixedCommissionPayoutsPerInfluencerDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: flatFeePercentageFixedCommissionPayoutsPerInfluencerQueryKeys.all });
		},
	});
}
